const becomeSellerAf = {
  breadcrumbs: {
    home: 'کور',
    becomeSeller: 'پلورونکی شئ'
  },
  hero: {
    title: 'پلورونکی شئ',
    subtitle: 'د ګرامین بازار سره خپله سوداګري وده ورکړئ او میلیونونه پیرودونکي ته ورسیدئ',
    cta: 'اوس پیل کړئ'
  },
  stats: [
    { value: '50,000+', label: 'فعال پلورونکي' },
    { value: '98%', label: 'په وخت کې تادیه' },
    { value: '300%', label: 'د پلور اوسط وده' },
    { value: '4.8/5', label: 'د پلورونکي رضایت' }
  ],
  benefits: {
    title: 'د پلور ګټې',
    items: [
      { title: 'د پلور زیاتول', description: 'زموږ له 1M+ پیرودونکو سره خپل محصولات ته ورسیدئ' },
      { title: 'ډیر ګټه اخیستل', description: 'د سیالي وړ کمیشن نرخونه او ګړندي تادیه' },
      { title: '24/7 ملاتړ', description: 'زموږ د پلورونکي ملاتړ ټیم تل ستاسو سره دی' },
      { title: 'سالم معاملات', description: 'په بشپړه توګه سالم او روښانه د تادیې سیسټم' },
      { title: 'ګړندي تنظیم', description: 'په 24 ساعتونو کې خپله دکان پیل کړئ' },
      { title: 'د پلور تحلیل', description: 'تفصيلي راپورونه او د پلور تعقیب' }
    ]
  },
  steps: {
    title: 'څنګه پیل کول',
    stepNumbers: ['1', '2', '3'],
    items: [
      { title: 'ثبتول', description: 'د خپلو شخصي او سوداګریز معلوماتو سره ثبت شئ' },
      { title: 'تصدیق', description: 'زموږ ټیم ستاسو معلومات تصدیق کوي او په 24 ساعتونو کې منل کوي' },
      { title: 'د پلور پیل', description: 'محصولات اپلوډ کړئ او پلور پیل کړئ' }
    ]
  },
  cta: {
    title: 'نن خپله ډیجیټل سوداګري پیل کړئ',
    subtitle: 'د ګرامین بازار سره یوځای شئ او خپله سوداګري نوي لوړو ته ورسوئ',
    button: 'د پلورونکي په توګه یوځای شئ'
  },
  transformDreams: {
    title: 'د ګرامین بازار سره خپل خوبونه بدل کړئ',
    content: [
      'تصور کړئ چې خپله سوداګري وده کوي—نه یوازې د پیژندل شویو مخونو سره، بلکې له هر کلی څخه د نوي پیرودونکو سره، چې هر یو یې تاسو ته د لومړي ځل لپاره پیژني. په ګرامین بازار کې، ستاسو محصولات د هغو خلکو د ورځني ژوند برخه کیږي چې هیڅکله په بازار کې پیرود نه دی کړی.',
      'زموږ ډیر ځواکمن بازارموندنه د کلیوالي ټولنو ته ژور رسيږي، هغه ګاونډیان او ملګري راګډوي چې غواړي د محلي پلورونکو (لکه تاسو) ملاتړ وکړي. زموږ تازه سروی څه ډیر ډیر ښه ښودل چې نږدې 30% زموږ پیرودونکي د لومړي ځل بازارموندنه کونکي دي، چې چمتو او لیوال دي چې له تاسو څخه پیرود وکړي.',
      'دا هغه فرصت دی چې تاسو هیڅکله نه لرلی—د هغو خلکو سره اړیکه چې د لاسرسي څخه بهر وو، دوی ته په خپل کیسه کې ښه راغلاست ویل، او خپل پلورونه له 50% څخه تر 100% یا ډیر زیاتول. د ګرامین بازار سره یوځای شئ—نه یوازې د یو پلیټفارم په توګه، بلکې د یو خوځښت په توګه.',
      'راځئ چې امید، فرصت او برکت ستاسو کورنۍ، ستاسو کلی او ستاسو خوبونو ته راوړو. پیرودونکي انتظار کوي. دا ستاسو وخت دی چې ځلیدئ.'
    ]
  }
};

export default becomeSellerAf;
